import {useOnMount} from 'shared/web';

import {usePairableCall} from '../../../hooks/usePairableCall';

interface ForgetPairableCallProps {
  callId: string;
}

/** Renders nothing: drops the call from pairing, e.g. once the backend no longer has it. */
export function ForgetPairableCall(props: ForgetPairableCallProps) {
  const {store} = usePairableCall();

  useOnMount(() => store.dismiss(props.callId));

  return null;
}
